import React from "react";
import TimberStorageListItem from "../../components/timberStorage/TimberStorageList/TimberStorageListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const TimberStorageListPage = ()  => {

    useTitle(t`List Timber Storage`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <TimberStorageListItem showAdd={true} {...query} />
        </Box>
    )
}

export default TimberStorageListPage;
